import { render, staticRenderFns } from "./CommentGroup.vue?vue&type=template&id=3156f0c4&scoped=true&"
import script from "./CommentGroup.vue?vue&type=script&lang=js&"
export * from "./CommentGroup.vue?vue&type=script&lang=js&"
import style0 from "./CommentGroup.vue?vue&type=style&index=0&id=3156f0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156f0c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VDivider,VIcon,VRow,VSpacer})
